module.exports = __webpack_public_path__ + "img/42.43dc9e85.png";